import * as React from "react";
import type { SVGProps } from "react";
const SvgFileX02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.8 21.6H6.6a2.4 2.4 0 0 1-2.4-2.4V4.8a2.4 2.4 0 0 1 2.4-2.4h10.8a2.4 2.4 0 0 1 2.4 2.4v7.8m0 9-2.4-2.4m0 0L15 16.8m2.4 2.4L15 21.6m2.4-2.4 2.4-2.4M8.4 7.2h7.2m-7.2 3.6h7.2m-7.2 3.6H12"
    />
  </svg>
);
export default SvgFileX02;
